<app-general-search-input
  [title]="title | translate"
  [expanded]="group.get('option')?.value"
>
  <ng-template>
    <form [formGroup]="group" class="easy-form">
      <mat-form-field class="smalle">
        <app-easy-select
          #selectField
          label=""
          formControlName="option"
          [options]="enum"
          [valueAttribute]="data.valueAttribute ?? ''"
          [labelAttribute]="data.labelAttribute ?? ''"
          [showSelectedLabels]="data.showSelectedLabels ?? false"
          [multiple]="data.isMultiple ?? false"
          (ngModelChange)="valueChanged($event)"
        ></app-easy-select>
      </mat-form-field>
    </form>
  </ng-template>
</app-general-search-input>
